import { utagLinkGeneric } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

function initBreadcrumbTracking () {

	const breadcrumbItemLinks = document.querySelectorAll('.breadcrumbNav__listItemLink');
	breadcrumbItemLinks.forEach((link) => {

		link.addEventListener('click', (e) => {

			const linkLabel = (e.target as HTMLAnchorElement).getAttribute('name');

			utagLinkGeneric({
				eventCategory: 'Breadcrumb',
				eventAction: 'Click',
				eventLabel: linkLabel
			});

			setGenericEvent({
				event_name: 'breadcrumb_click',
				breadcrumb_info: linkLabel
			});

		});

	});

	const removeBreadcrumbLinks = document.querySelectorAll('.breadcrumbNav__listItemRemoveLink');
	removeBreadcrumbLinks.forEach((link) => {

		link.addEventListener('click', (e) => {

			const removeLabel = (e.target as HTMLAnchorElement).getAttribute('name');

			utagLinkGeneric({
				eventCategory: 'Breadcrumb',
				eventAction: 'Remove',
				eventLabel: removeLabel
			});

			setGenericEvent({
				event_name: 'breadcrumb_remove',
				breadcrumb_info: removeLabel
			});

		});

	});

}

export default initBreadcrumbTracking;
